import { isNative } from '@whelk/const/src/env';

export const focusInput = () => {
  if (isNative) {
    return;
  }
  console.log('focusInput focus');
  const input = document.querySelector<HTMLInputElement>('#chat-input');
  input?.focus();
};

export const persistentFocus = () => {
  console.log('persistentFocus focus');
  // 判断当前元素是否是focus状态
  const input = document.querySelector<HTMLInputElement>('#chat-input');
  if (input?.focus) {
    console.log('input', input?.focus);
    console.log('input is focus');
    input?.focus();
    return;
  }
};

export const outFocus = () => {
  console.log('outFocus focus');
  // 移除foucs
  const input = document.querySelector<HTMLInputElement>('#chat-input');
  input?.blur();
};

export const focusPhoneInput = () => {
  console.log('focusPhoneInpu focust');
  const input = document.querySelector<HTMLInputElement>('.phone-input');
  input?.focus();
};

export const focusCodeInput = () => {
  console.log('focusCodeInpu focust');
  const input = document.querySelector<HTMLInputElement>('.code-input');
  input?.focus();
};
